<template>
    <div class="ma-5">
        <v-data-table
            :headers="headers"
            :items="desserts"
            :search="search"
            :height="320"
            :fixed-header="true"
            class="elevation-3"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Cadastro de Zonas</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>

                    <v-text-field
                        class="mr-10"
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Pesquisar"
                        single-line
                        hide-details
                    ></v-text-field>

                    <v-dialog persistent v-model="dialog" max-width="700px">
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark class="mb-2" v-on="on">Novo</v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col class="pa-0 pr-md-2" cols="12" md="6">
                                            <v-text-field
                                                outlined
                                                type="number"
                                                v-model.number="editedItem.zona"
                                                label="Zona*"
                                                autofocus
                                                :error-messages="zonaErrors"
                                                @input="$v.editedItem.zona.$touch()"
                                                @blur="$v.editedItem.zona.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col class="pa-0 pl-md-2" cols="12" md="6">
                                            <v-text-field
                                                outlined
                                                type="number"
                                                v-model.number="editedItem.eleitorado_estimado"
                                                label="Eleitorado estimado"
                                                hint="Nº de eleitores da zona (opcional)"
                                                persistent-hint
                                            ></v-text-field>
                                        </v-col>
                                        <v-col class="pa-0" cols="12">
                                            <v-autocomplete
                                                outlined
                                                multiple
                                                chips
                                                small-chips
                                                deletable-chips
                                                v-model="editedItem.municipios"
                                                :items="selects.municipios"
                                                item-text="nome"
                                                item-value="id"
                                                label="Municípios abrangidos pela zona"
                                                hint="Uma zona pode abranger mais de um município"
                                                persistent-hint
                                            ></v-autocomplete>
                                        </v-col>
                                        <v-col class="pa-0 mt-3" cols="12">
                                            <v-select
                                                outlined
                                                clearable
                                                v-model="editedItem.id_zona_geografica"
                                                :items="selects.zonas_geograficas"
                                                item-text="nome"
                                                item-value="id"
                                                label="Região da capital (só para zonas de Manaus)"
                                                hint="Deixe em branco para zonas do interior"
                                                persistent-hint
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Sair</v-btn>
                                <v-btn color="blue darken-1" text @click="save">Salvar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:item.municipios="{ item }">
                <span v-if="item.municipios && item.municipios.length" class="caption">
                    {{ nomesMunicipios(item.municipios) }}
                </span>
                <span v-else class="grey--text caption">—</span>
            </template>
            <template v-slot:item.regiao_nome="{ item }">
                <v-chip v-if="item.regiao_nome" x-small color="primary" outlined>{{ item.regiao_nome }}</v-chip>
                <span v-else class="grey--text">—</span>
            </template>
            <template v-slot:item.eleitorado_estimado="{ item }">
                <span v-if="item.eleitorado_estimado">{{ Number(item.eleitorado_estimado).toLocaleString('pt-BR') }}</span>
                <span v-else class="grey--text">—</span>
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                    title="Editar Zona"
                    class="mr-2"
                    @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                    title="Remover Zona"
                    @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>
    </div>
</template>
<script>
    import { required, numeric } from 'vuelidate/lib/validators'
    import AclAPI from "./../../api/acl";

    export default {
        name: "Zonas",
        data: () => ({
            dialog: false,
            atualizar: 0,
            search: '',
            headers: [
                { text: 'ID', value: 'id' },
                { text: 'Zona', align: 'left', value: 'zona' },
                { text: 'Municípios abrangidos', value: 'municipios', sortable: false },
                { text: 'Região (capital)', value: 'regiao_nome' },
                { text: 'Eleitorado', value: 'eleitorado_estimado' },
                { text: 'Ações', value: 'action', sortable: false },
            ],
            desserts: [],
            selects: {
                municipios: [],
                zonas_geograficas: [],
            },
            editedIndex: -1,
            editedItem: {
                idzona: '',
                zona: '',
                municipios: [],
                id_zona_geografica: null,
                eleitorado_estimado: null,
            },
            defaultItem: {
                idzona: '',
                zona: '',
                municipios: [],
                id_zona_geografica: null,
                eleitorado_estimado: null,
            },
        }),

        validations: {
            editedItem: {
                zona: {
                    required,
                    numeric,
                    unica(value) {
                        if (value === '' || value === null || value === undefined) return true;
                        const idAtual = this.editedItem.idzona;
                        return !this.desserts.some(z =>
                            Number(z.zona) === Number(value) && z.id !== idAtual
                        );
                    },
                },
            }
        },

        computed: {
            zonaErrors() {
                const errors = []
                if (!this.$v.editedItem.zona.$dirty) return errors
                !this.$v.editedItem.zona.required && errors.push('Campo Obrigatório.')
                !this.$v.editedItem.zona.numeric && errors.push('Informe apenas números.')
                !this.$v.editedItem.zona.unica && errors.push('Zona já cadastrada.')
                return errors
            },
            formTitle() {
                return this.editedIndex === -1 ? 'Nova Zona' : 'Editar Zona'
            },
        },

        watch: {
            dialog(val) {
                val || this.close()
            },
        },

        created() {
            this.initialize()
        },

        methods: {
            initialize() {

                const headers = this.Helpers.iniciarRequisicao();

                AclAPI.getZonas(headers)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);

                        if (response.status == 200) {
                            this.desserts = response.data.zonas;
                        }
                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })

                AclAPI.getMunicipios(headers)
                    .then(response => {
                        localStorage.setItem('token', response.data.token);
                        if (response.status == 200) {
                            this.selects.municipios = response.data.municipios || [];
                        }
                    })
                    .catch(() => { this.Helpers.logout(); })

                AclAPI.getZonasGeograficas(headers)
                    .then(response => {
                        localStorage.setItem('token', response.data.token);
                        if (response.status == 200) {
                            this.selects.zonas_geograficas = response.data.zonas_geograficas || [];
                        }
                    })
                    .catch(() => { this.Helpers.logout(); })

                this.$store.dispatch("loading/habilitarLoading", false);
            },

            nomesMunicipios(ids) {
                return (ids || [])
                    .map(id => {
                        const m = this.selects.municipios.find(x => x.id === id);
                        return m ? m.nome : id;
                    })
                    .join(', ');
            },

            editItem(item) {
                this.editedIndex = this.desserts.indexOf(item)
                this.editedItem = {
                    idzona: item.id,
                    zona: item.zona,
                    municipios: Array.isArray(item.municipios) ? item.municipios.slice() : [],
                    id_zona_geografica: item.id_zona_geografica || null,
                    eleitorado_estimado: item.eleitorado_estimado || null,
                }
                this.dialog = true
            },

            deleteItem(item) {

                this.editedItem = { idzona: item.id, zona: item.zona }

                if (confirm('Deseja remover a zona?')) {

                    const headers = this.Helpers.iniciarRequisicao();
                    const params = { idzona: this.editedItem.idzona };

                    this.$store.dispatch("loading/addRequisicao",
                        AclAPI.delZona(headers, params)
                            .then(response => {

                                const token = response.data.token;
                                localStorage.setItem('token', token);

                                if (response.status == 200) {
                                    this.editedItem = Object.assign({}, this.defaultItem)
                                    this.initialize();
                                    this.$emit('atualizarApp', this.atualizar += 1)
                                }
                            })
                            .catch(() => {
                                this.Helpers.logout();
                            })
                    )

                } else {
                    this.editedItem = Object.assign({}, this.defaultItem)
                }
            },

            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                    this.$v.$reset()
                }, 300)
            },

            save() {

                this.$v.$touch();

                if (!this.$v.$invalid) {

                    const headers = this.Helpers.iniciarRequisicao();
                    const params = {
                        idzona: this.editedItem.idzona || 0,
                        zona: Number(this.editedItem.zona),
                        municipios: this.editedItem.municipios || [],
                        id_zona_geografica: this.editedItem.id_zona_geografica || null,
                        eleitorado_estimado: this.editedItem.eleitorado_estimado || null,
                    };

                    this.$store.dispatch("loading/addRequisicao",
                        AclAPI.addZona(headers, params)
                            .then(response => {

                                const token = response.data.token;
                                localStorage.setItem('token', token);

                                if (response.status == 200) {
                                    this.initialize();
                                    this.$emit('atualizarApp', this.atualizar += 1)
                                    this.close()
                                }
                            })
                            .catch(error => {
                                if (error.response && error.response.status === 409) {
                                    this.$store.dispatch('snackbar/habilitarSnackBar', {
                                        ativo: true,
                                        mensagem: 'Zona já cadastrada.',
                                        color: 'error',
                                        timeout: 4000,
                                    });
                                } else {
                                    this.Helpers.logout();
                                }
                            })
                    )
                }
            },
        },
    }
</script>
<style scoped>
</style>
